import { gql, DocumentNode } from '@apollo/client';

export interface GetSubjectsByCourseQueryVariables {
  courseId: string;
}

export interface GetSubjectsByCourseQueryResult<TSubject> {
  subjects: TSubject[];
}

export const getSubjectsByCourseQuery = (subjectsTreeFragment: DocumentNode) => gql`
  query SubjectsByCourse($courseId: String!) {
    subjects(courseId: $courseId) @rest(type: "Subject", path: "courses/{args.courseId}/subjects") {
      ...SubjectsTree
    }
  }
  ${subjectsTreeFragment}
`;
